import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

let cfg = null;
let loading = false;
const subs = new Set();

export const refreshGames = () => api.get("/games/config").then(({ data }) => { cfg = data; subs.forEach((f) => f()); });
const subscribe = (f) => {
  subs.add(f);
  if (!cfg && !loading) { loading = true; refreshGames().catch(() => {}).finally(() => { loading = false; }); }
  return () => subs.delete(f);
};

if (typeof window !== "undefined") window.addEventListener("focus", () => { if (cfg) refreshGames().catch(() => {}); });

export const useGames = () => useSyncExternalStore(subscribe, () => cfg);
export const gameOn = (c, id) => !c || !c[id] || c[id].enabled !== false;
export const gameBlocked = (c, id) => !!c?.[id]?.blocked;
export const ROUTE_GAME = { "/lotto": "lotto", "/teams": "teams", "/haustier": "pet", "/spielplatz": "pet", "/stimmung": "mood" };
